
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"20","height":"19","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M18.75 18.94h-7.253a.75.75 0 010-1.5h7.253a.75.75 0 010 1.5z","fill":"#A4A8C0"}}),_c('mask',{staticStyle:{"mask-type":"alpha"},attrs:{"id":"content","maskUnits":"userSpaceOnUse","x":"0","y":"0","width":"18","height":"19"}},[_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M0 0h17.18v18.94H0V0z","fill":"#fff"}})]),_c('g',{attrs:{"mask":"url(#content)"}},[_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M11.11 2.017L1.695 13.792a.879.879 0 00-.17.755l.68 2.885 3.04-.038a.949.949 0 00.732-.352c3.217-4.025 9.35-11.7 9.524-11.924a1.36 1.36 0 00.142-1.004 1.411 1.411 0 00-.652-.887 328.898 328.898 0 01-1.808-1.398 1.497 1.497 0 00-2.073.188zM1.613 18.94a.75.75 0 01-.73-.577l-.819-3.471a2.371 2.371 0 01.46-2.037l9.42-11.782c.004-.004.007-.01.011-.013 1.033-1.235 2.901-1.417 4.161-.406l1.723 1.339c.608.362 1.083 1.009 1.263 1.775.18.758.05 1.54-.368 2.2-.03.05-.058.092-9.586 12.012a2.447 2.447 0 01-1.886.914l-3.639.046h-.01z","fill":"#A4A8C0"}})]),_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M14.223 8.685a.753.753 0 01-.457-.155L8.314 4.342a.75.75 0 01.914-1.19l5.453 4.188a.75.75 0 01-.458 1.345z","fill":"#A4A8C0"}})])
          )
        }
      }
    